import PropTypes from 'prop-types';

import OInput from '../../../UI/FormControls/OInput';
import { useTranslation } from 'react-i18next';
// import OAutocomplete from '../../../UI/MuiAutocomplete';

const Inputs = ({ formData, setFormData }) => {
  const { t, i18n } = useTranslation();
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // const handleAutocompleteChange = (event) => {
  //   const { id, vrednost } = event;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     idKupca: id,
  //     nazivKupca: vrednost,
  //   }));
  // };

  return (
    <div style={{ display: 'flex', marginBottom: '20px', flexWrap: 'wrap' }}>
      {/* <OAutocomplete
        label="Naziv Kupca"
        data={korisniciData}
        value={formData.nazivKupca}
        style={{ width: '200px', cursor: 'pointer' }}
        handleClick={handleAutocompleteChange}
      /> */}
      <OInput
        label={t('locationName')}
        name="naziv"
        value={formData.naziv}
        handleChange={handleInputChange}
        style={{ width: '300px', marginRight: '10px' }}
      />
      <OInput
        label={t('adress')}
        name="adresa"
        value={formData.adresa}
        handleChange={handleInputChange}
        style={{ width: '300px', marginRight: '10px' }}
      />
      {/* <OInput
        label="Kontakt Osoba"
        name="kontaktOsoba"
        value={formData.kontaktOsoba}
        handleChange={handleInputChange}
        style={{ width: '300px', marginRight: '10px' }}
      />
      <OInput
        label="Kontakt Telefon"
        name="kontaktTelefon"
        value={formData.kontaktTelefon}
        handleChange={handleInputChange}
        style={{ width: '300px', marginRight: '10px' }}
      /> */}
    </div>
  );
};

Inputs.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
};

export default Inputs;
